/**
 * For maintainability we should separate controllers into their own modules
 */
angular.module('acme.view.application.groups.users.controllers', [
  'ui.router',
  'ui.bootstrap',
  'acme.common.service.api',
  'acme.common.factory.notice',
  'acme.view.application.groups.users.addModal.controllers',
  'acme.view.application.groups.users.removeModal.controllers',
  'acme.common.factory.gridState'
])

.controller('GroupsUsersController', ['$scope', '$state', '$timeout', '$uibModal', 'ApiService', 'NoticeFactory', 'GroupData', 'GridStateFactory', function($scope, $state, $timeout, $uibModal, ApiService, NoticeFactory, GroupData, GridStateFactory) {

    $scope.groupsUsers = {

      model: [],
      addModal: {},
      removeModal: {},
      group: {},

      isLoaded: false,

      notice: new NoticeFactory(),

      gridState: new GridStateFactory(),

      grid: {
        pageSize: 50,
        showFooter: true,
        paginate: true,
        multiselect: false,
        enableRowSelection: false,
        useExternalPagination: true,
        useExternalSorting: true,
        columns: [
          {
            field: 'view',
            displayName: 'View',
            width: 50,
            onCellNavClick: function(row, col) {
              $scope.groupsUsers.gridDoubleClick(row);
            },
            enableSorting: false,
            enableHiding: false,
            cellTemplate: '<div class="ui-grid-cell-contents"><a data-ng-click="grid.appScope.onGridDblClick(row)" role="link">View<span class="sr-only"> Details for {{ row.entity.firstName }} {{ row.entity.lastName }}</span></a></div>'
          },
          {
            field: 'firstName',
            displayName: 'First Name'
          },
          {
            field: 'lastName',
            displayName: 'Last Name'
          },
          {
            field: 'email',
            displayName: 'Email'
          },
          {
            field: 'remove',
            displayName: 'Remove',
            onCellNavClick: function(row, col) {
              $scope.groupsUsers.remove(row.entity.id);
            },
            enableSorting: false,
            enableHiding: false,
            cellTemplate: '<div class="ui-grid-cell-contents"><a data-ng-click="grid.appScope.remove(row.entity.id)" role="button">Remove<span class="sr-only"> - Opens Dialog</span></a></div>'
          }
        ]
      },

      init: function() {

        this.gridState.updateGridState(null, this.grid.pageSize, 'name', 'asc');

        this.getUsers($state.params.id);

        // Content title set after initialization
        if (GroupData.data && GroupData.data.success) {
          this.success.init(GroupData);
        }else{
          this.error.init(GroupData);
        }

      },

      getUsers: function(id) {
        ApiService.groups.users.list(id, this.gridState.getGridState()).then(this.success.getUsers, this.error.getUsers);
      },

      findUser: function(id) {

        var i, ii,
            r = false;

        for (i=0,ii=this.model.length;i<ii;i++) {
          if (this.model[i].id === id) {
            r = {
              user: this.model[i],
              index: i
            };
          }
        }

        return r;

      },

      getUserIds: function() {
        var i, ii,
            ids = [];

        for (i=0,ii=this.model.length;i<ii;i++) {
          ids.push(this.model[i].userGroupMapId);
        }

        return ids;
      },

      addBatch: function(list) {

        ApiService.groups.userMaps.batchCreate({ mappings: list.mappings }).then(function (response, status, headers, config) {
          var i, ii,
              j, jj,
              self = $scope.groupsUsers,
              mappings = response.data.payload;

          // Remap userGroupMapIds to model for deletions to work
          for (i=0,ii=mappings.length;i<ii;i++) {
            for (j=0,jj=list.users.length;j<jj;j++) {
              if (mappings[i].userId === list.users[j].id) {
                list.users[j].userGroupMapId = mappings[i].id;
              }
            }
          }
          self.model = list.users;
          self.success.addBatch(response, status, headers, config);
        }, this.error.addBatch);
      },

      add: function() {
        var self = $scope.groupsUsers;

        self.addModal = $uibModal.open({
          templateUrl: 'views/application/views/groups/users/modals/addUsers.tpl.html',
          size: 'md',
          controller: 'GroupsUsersAddModalController',
          resolve: {
            groupData: function() {
              return self.group;
            },
            groupUsers: function() {
              return self.model;
            }
          }
        });

        // Invoked when modal completes with close(params)
        self.addModal.result.then(function (list) {
          var ids = self.getUserIds();
          if (ids.length > 0) {
            ApiService.groups.userMaps.remove({ ids: ids }).then(function (response) {
              // Clear users to prevent duplicates
              self.model = [];
              // Add users
              self.addBatch(list);
            }, self.error.add);
          }else{
            self.addBatch(list);
          }
        }, function () {
          // Do nothing
        });
      },

      remove: function(id) {
        var self = $scope.groupsUsers,
            found = self.findUser(id);

        self.removeModal = $uibModal.open({
          templateUrl: 'views/application/views/groups/users/modals/removeUser.tpl.html',
          size: 'md',
          controller: 'GroupsUsersRemoveModalController',
          resolve: {
            currentUser: function() {
              return found.user;
            }
          }
        });

        // Invoked when modal completes with close(params)
        self.removeModal.result.then(function () {
          ApiService.groups.userMaps.remove({ ids: [found.user.userGroupMapId] }).then(function(response, status, headers, config) {
            self.model.splice(found.index, 1);
            self.success.remove(response, status, headers, config);
          }, function(response, status, headers, config) {
            self.error.remove(response, status, headers, config);
          });
        }, function () {
          // Do nothing
        });
      },

      gridDoubleClick: function(row) {
        console.log('GroupUsersController::gridDoubleClick', row);
        $state.go('application.users.detail', { id: row.entity.id });
      },

      success: {
        init: function(response) {
          var self = $scope.groupsUsers;
          self.group = response.data.payload;
          $scope.$emit('Application::contentTitleChange', {
            title: self.group.displayName || self.group.name,
            buttonRight: {
              label: 'Add Users',
              permissions: 'USER_GROUPS_UPDATE',
              action: function() {
                $scope.groupsUsers.add();
              }
            }
          });
        },
        getUsers: function(response) {
          var self = $scope.groupsUsers;
          //next tick
          $timeout(function() {
            self.model = response.data.payload.list;
            self.gridState.setPropertyValue('totalItems', response.data.payload.pagination.count);
            self.isLoaded = true;
          }, 0);
        },
        add: function(response) {},
        addBatch: function(response) {},
        remove: function(response) {}
      },

      error: {
        init: function(response) {
          $scope.$emit('Application::contentTitleChange', {
            title: 'User Roles',
            buttonRight: {
              label: 'Add Users',
              action: function() {
                $scope.groupsUsers.add();
              }
            }
          });
        },
        getUsers: function(response) {
          var self = $scope.groupsUsers;
          self.isLoaded = true;
        },
        add: function(response) {},
        addBatch: function(response) {},
        remove: function(response) {}
      },

      onDataGridPaginate: function(newPage, pageSize) {
        var self = $scope.groupsUsers;
        self.gridState.updateGridState(newPage, pageSize);
        self.getUsers($state.params.id);
      },

      onDataGridSortChange: function(grid, columns) {
        var self = $scope.groupsUsers, data = columns[0];
        if(data) {
          self.gridState.updateGridState(null, null, data.field, data.sort.direction);
          self.getUsers($state.params.id);
        }
      }

    };

    $scope.groupsUsers.init();

}]);